import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import store from '../store/index'
import router from '../router'
//这里柚子引入的是element-ui中的提示框和加载框，用其他ui组件的要换一下
import { Message, Loading } from 'element-ui'


// 响应时间
axios.defaults.timeout = 5 * 1000
// let pathname = 'https://www.chuangpeiketang.com/'
let pathname = window.location.origin
// 配置cookie
// axios.defaults.withCredentials = true
// 配置请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 静态资源
Vue.prototype.$static = ''
axios.defaults.baseURL = pathname
var loadingInstance,instance

instance = axios.create({
    baseURL:pathname,
    timeout : 5 * 1000,
})
instance.interceptors.request.use(
    config => {
        if(store.state.token){ 
            config.headers = {'Content-Type': 'multipart/form-data' ,'x-manager-token':store.state.token }
        }
        return config
    },
)
Vue.config.productionTip = false
Vue.prototype.instance = instance


// 配置接口地址
//这里的接口地址是你地址的相同的前半部分，方便管理

// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
    config => {
        if(store.state.token){ 
            config.headers.common['x-manager-token'] = store.state.token;
        }
        loadingInstance = Loading.service({
            lock: true,
            text: '数据加载中，请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
        if (config.method === 'post') {
            config.data = qs.stringify(config.data)
        }
        return config
    },
    err => {
        loadingInstance.close()
        Message.error('请求错误')
        return Promise.reject(err)
    }
)
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
    res => {
        loadingInstance.close()
        if(res.status === 200){
            if(res.data.code === 2001 || res.data.code === 2002){
                store.commit('deleInfo')
                store.commit('deleteConfig')
                store.commit('deleteProvince')  
            }else if(res.data.code === 1010){
                console.log('暂无数据')
            }else if(res.data.code != 0){
                Message.error(res.data.message)
            }
        }
        return res
    },
    err => {
        loadingInstance.close()
        Message.error('请求失败，请稍后再试')
        
        if(err.data.code === 2001 || err.data.code === 2002){
            store.commit('deleInfo')
            store.commit('deleteConfig')
            store.commit('deleteProvince')  
        }
        
        return Promise.reject(err)
    }
)
// 发送请求
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(
                res => {
                    resolve(res.data)
                },
                err => {
                    reject(err.data)
                }
            )
            .catch(err => {
                console.log(err)
            })
    })
}
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            }).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
    })
}
router.beforeEach((to, from, next) => {
  let token = JSON.parse(localStorage.getItem('res')) || store.state.token;
  if(token){
    if(to.path === '/'){
        next({path:'/index'})
      }else{
        next()
      }
    }else{
      if(to.path === '/'){
        next()
      }else{
        next({path:'/'})
      }
    } 
})
